import type { HTMLAttributes, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { clsx } from 'clsx';

export interface BreadcrumbItemProps {
    children: ReactNode;
    href: string;
    state: 'default' | 'active' | 'first';
    dataTestid?: string;
    htmlAttributes?: HTMLAttributes<HTMLLIElement>;
}

export const BreadcrumbItem = ({
    children,
    href,
    state = 'default',
    dataTestid,
    htmlAttributes,
}: BreadcrumbItemProps) => (
    <li
        className={clsx(['w-fit', 'text-xs'], {
            'px-2 text-gray-600 hover:underline': state === 'default',
            'px-2 font-bold pointer-events-none text-gray-600': state === 'active',
            'text-gray-700 font-medium': state === 'first',
        })}
        data-testid={dataTestid}
        {...htmlAttributes}
    >
        <Link
            className={clsx(
                'inline-block rounded outline-0 focus-visible:border focus-visible:border-solid focus-visible:border-violet-400',
                state === 'first' ? 'bg-gray-100 px-3 py-1 hover:bg-gray-200' : 'px-2 py-1'
            )}
            to={href}
        >
            {children}
        </Link>
    </li>
);
